/*
 *  Server Sort Processor Service
 *  Processes sort parameters from data sources into sort parameters for the trackerbase api
 *
 *  Angular module: trackerbase-app.services.server-sort-processor-service
 *  Service Name: ServerSortProcessor
 *
 */
import angular from "angular";

import Assert from "tbAssert";

const trackingEventSortFieldMappingTable = new Map([
    ["eventDisplayName","name"],
    ["startDate", "start"],
    ["endDate", "end"],
    ["statusName", "status"],
    ["locationState.shortName", "locationcitystate"]
]);

function processEventSortSpec(eventSortSpec) {
    let sortFieldName = trackingEventSortFieldMappingTable.get(eventSortSpec.field);
    if (angular.isUndefined(sortFieldName))
    {
        return null;
    }

    let sortDir = "asc";
    if (eventSortSpec.dir === "desc")
    {
        sortDir = "desc";
    }

    return `${sortFieldName}|${sortDir}`;
}

const mLogSvc = new WeakMap();

class ServerSortProcessorService {
    constructor($log) {
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        mLogSvc.set(this, $log);
    }

    toString() {
        return "ServerSortProcessorService";
    }

    ProcessEventSort(eventSortData) {
        mLogSvc.get(this).debug("Event Sort Parameter");
        mLogSvc.get(this).debug(eventSortData);

        if (angular.isArray(eventSortData)) {
            let eventSortDefs = eventSortData
                .map((sortSpec) => processEventSortSpec(sortSpec))
                .filter(function(fieldSpec) {
                    return (fieldSpec != null);
                });

            if (eventSortDefs.length !== 0)
            {
                let eventSortDef = eventSortDefs.join("||");
                return eventSortDef;
            }
            else {
                return null;
            }
        }
        else {
            let eventSingleSortSpec = processEventSortSpec(eventSortData);
            if (eventSingleSortSpec != null) {
                return eventSingleSortSpec;
            }
            else {
                return null;
            }
        }
    }
}

ServerSortProcessorService.$inject = [ "$log" ];

export default angular
    .module("trackerbase-app.services.server-sort-processor-service", [
    ])
    .service("ServerSortProcessor", ServerSortProcessorService)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/services/ServerSortProcessorService.js
// module id = fR4n
// module chunks = 1